<ng-container
  *ngIf="{
    value: (value$ | async),
    isFocus: (isFocus$ | async),
    isShow: (show$ | async)
  } as streams$"
>
  <int-labeled-field-box
    #box
    intNativeElement
    [isActive]="isActive"
    [isFocus]="streams$.isFocus || false"
    [label]="placeholder"
    (click)="onContainerClick()"
  >
    <ng-container ngProjectAs="center-position">
      <ng-container>
        <input
          readonly
          class="_field"
          type="text"
          [value]="displayDataFormatter"
          (focus)="onFocus()"
          (blur)="onBlur()"
        >
      </ng-container>
    </ng-container>
    <ng-container ngProjectAs="right-position">
      <div class="clear-wrap" *ngIf="clearable">
        <int-clear-action-default (onClear)="onClear($event)"></int-clear-action-default>
      </div>
    </ng-container>
    <ng-content select="right-position"></ng-content>
  </int-labeled-field-box>

  <int-portal-slot
    [targetRef]="box.elementRef.nativeElement"
    [show]="streams$.isShow || streams$.isFocus"
    [satellitePayload]="{customDropWidth: 280, horizontalAlign: 'start'}"
  >
    <ng-template intPortalSlotTemplate>
      <int-dropdown-area
        class="portal-element"
        [excludeElementsForClickOutside]="box.elementRef.nativeElement"
        (clickOutside)="clickOutSide()"
      >
        <int-month-calendar
          [currentDate]="streams$.value"
          [type]="type"
          (onChange)="onCalendarChange($event)"
        ></int-month-calendar>
      </int-dropdown-area>
    </ng-template>
  </int-portal-slot>
</ng-container>
